import React, {useEffect} from 'react';
import TableWrapper from './TableWrapper';
import RowTable from './RowTable';
import { useDispatch, useSelector } from 'react-redux';
import { getDocument, userSelector } from '../../services/reduxSlices/UserSlice';

/**
 * Composant présent sur la boite de réception 
 * Tableau contenant les documents
 * 
 * @returns ListdocSignTable
 */
const ListdocSignTable = () => {
	const dispatch = useDispatch()
	
	useEffect(() => {
		dispatch(getDocument())
	},[])
	
	const { signDocuments } = useSelector(userSelector)
	console.log(signDocuments)

    return(
		<TableWrapper>
			{
				signDocuments.data && signDocuments.data.map((rw)=>{
					return <RowTable data={rw} />
				})
			}
		</TableWrapper>
    );
}

export default ListdocSignTable;